import { UserSession } from '../types';
import env from '../env';
import { createCacheableFetch } from '@statflo/fetch';
import * as moment from 'moment';

const cachedFetch = createCacheableFetch();

export default async function dncService(banId: string, token: string, phone: string | number, session: UserSession) {
    if (session.features.indexOf(208) > -1) {
        const cpmEndPoint = `${env.WEBAPP_HOST}v2/api/cpm?phone_number=${phone}&dealer_id=${session.dealer_id}`;
        const cpmRequestInit: RequestInit = {
            method: 'GET',
            headers: new Headers({
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }),
            mode: 'cors',
        };

        const response = await fetch(cpmEndPoint, cpmRequestInit);
        const resp = await response.json();
        const obj = {};
        obj[banId] = false;

        if (resp.data && resp.data.SMS) {
            obj[banId] = resp.data.SMS[0].active;
        }
        return obj;
    }

    const currentTime = moment().utc();
    const endPoint = `${env.WEBAPP_HOST}v2/api/dnc?ban_id=${banId}&time=${currentTime}`;
    const requestInit: RequestInit = {
        method: 'GET',
        headers: new Headers({
            authorization: `Bearer ${token}`
        }),
        mode: 'cors',
    };

    const contact = await cachedFetch(endPoint, requestInit);
    console.log('contact', contact);
    return contact;
}



// WEBPACK FOOTER //
// ./src/services/DncService.ts